/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { observer } from 'mobx-react';
import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { CluMigrationInfoDto, CluMigrationModal } from 'src/luis/verticals/cluMigrationModal/CluMigrationModal';
import { MigratingLuisApplicationsModal } from 'src/luis/verticals/cluMigrationModal/MigratingLuisApplicationsModal';
import { NextStepsModal } from 'src/luis/verticals/cluMigrationModal/NextStepsModal';
import { CluMigrationBanner } from 'src/luis/verticals/getStartedGuide/cluMigrationBanner/CluMigrationBanner';

export const CluMigrationManager = observer(() => {
    const { dispatcher, uiStore } = useGlobalState();

    const [cluMigrationInfoDto, setCluMigrationInfoDto] = React.useState<CluMigrationInfoDto>(null);

    return (
        <>
            <CluMigrationBanner />

            <CluMigrationModal
                hidden={uiStore.isCluMigrationModalHidden}
                onDismiss={() => {
                    dispatcher.dispatch('dismissCluMigration');
                }}
                onSubmit={(cluMigrationInfo: CluMigrationInfoDto) => {
                    setCluMigrationInfoDto(cluMigrationInfo);
                    dispatcher.dispatch('updateCluMigrationLuisApplicationsnModalVisibility', { isVisible: true });
                }}
            />

            <MigratingLuisApplicationsModal
                hidden={uiStore.isCluMigrationLuisApplicationsnModalHidden}
                cluMigrationInfoDto={cluMigrationInfoDto}
                onSubmit={() => {
                    dispatcher.dispatch('updateCluMigrationLuisApplicationsnModalVisibility', { isVisible: false });
                    dispatcher.dispatch('updateCluMigrationNextStepsModalVisibility', { isVisible: true });
                }}
            />

            <NextStepsModal
                hidden={uiStore.isCluMigrationNextStepsModalHidden}
                onDismiss={() => dispatcher.dispatch('updateCluMigrationNextStepsModalVisibility', { isVisible: false })}
            />
        </>
    );
});
